<template>
  <div>
    <b-card header="Create Office365 Calendar Event" header-tag="h4" body-class="mb-3 pb-2">
      <div class="row crm-row pr-4">
        <form role="form" @submit.prevent="eventSubmit" class="col-md-12">
          <div class="row">
            <div class="form-group col-md-12">
              <label for="eventCalendar">Select Calendar</label>
              <select id="eventCalendar" v-model="calendar_id" class="form-control">
                <option v-for="calendar in calendars" :key="calendar.id" :value="calendar.id"> {{ calendar.name }}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <label for="eventSubject">Add a title</label>
              <input type="text" v-model="event.subject" class="form-control" id="eventSubject" name="eventSubject" placeholder="Add a title">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <label>Invite attendees</label>
              <v-select taggable multiple no-drop v-model="attendees" class="crm-multiselect" id="eventInviteAttendee"/>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-4">
              <label for="eventStartDate">Event start date</label>
              <datepicker id="eventStartDate" :value="new Date()" name="eventStartDate" :input-class="['form-control']" :format="dateFormat" @input="selectStartDate" :use-utc="true"></datepicker>
            </div>
            <div class="form-group col-md-4">
              <label for="eventStartTime">Event start time</label>
              <vue-timepicker id="eventStartTime" close-on-complete v-model="timePicker.start" hide-clear-button/>
            </div>
            <div class="form-group col-md-4">
              <label for="eventEndTime">Event end time</label>
              <vue-timepicker id="eventEndTime" close-on-complete v-model="timePicker.end" hide-clear-button/>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label for="eventRepeat">Repeat</label>
              <select id="eventRepeat" v-model="repeat" class="form-control">
                <option value="never" selected>Repeat: Never</option>
                <option value="daily">Every day</option>
                <option value="weekly">Every week</option>
                <option value="monthly">Every month</option>
                <option value="yearly">Every year</option>
              </select>
            </div>
            <div class="form-group col-md-6">
              <label for="eventReminder">Reminder</label>
              <select id="eventReminder" v-model="event.reminderMinutesBeforeStart" class="form-control">
                <option value="0">Remind: Never</option>
                <option value="15" selected>15 mins before</option>
                <option value="30">30 mins before</option>
                <option value="45">45 mins before</option>
                <option value="60">1 hour before</option>
                <option value="120">2 hours before</option>
                <option value="180">3 hours before</option>
                <option value="240">4 hours before</option>
                <option value="300">5 hours before</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label for="eventLocation">Location</label>
              <input type="text" class="form-control" id="eventLocation" name="eventLocation" placeholder="Location" v-model="event.location.displayName">
            </div>
            <div class="form-group col-md-6">
              <label for="eventOnline">Online Meeting</label>
              <select id="eventOnline" v-model="onlineMeeting" class="form-control">
                <option value="">No online meeting</option>
                <option value="teamsForBusiness" selected>Team for business</option>
                <option value="skypeForBusiness">Skype for business</option>
                <option value="skypeForConsumer">Skype for customer</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <label for="eventDescription">Add a description</label>
              <textarea class="form-control" id="eventDescription" rows="5" name="eventDescription" placeholder="Add a description" v-model="event.body.content"/>
            </div>
          </div>
          <button type="submit" class="btn crm-submit-btn" @click="createEvent()">Create New Event</button>
        </form>
      </div>
    </b-card>
  </div>
</template>
<script>
import "vue-select/src/scss/vue-select.scss";
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
  name: 'create_calendar_event',
  components: {
    vSelect,
    Datepicker,
    VueTimepicker
  },
  data() {
    return {
      event: {
        subject: '',
        attendees: [],
        start: {
          dateTime: "",
          timeZone: "Europe/London"
        },
        end: {
          dateTime: "",
          timeZone: "Europe/London"
        },
        recurrence: {},
        reminderMinutesBeforeStart: 15,
        isReminderOn: true,
        location: {
          displayName: ""
        },
        body: {
          contentType: "text",
          content: ""
        },
        isOnlineMeeting: false,
        onlineMeetingProvider: null,
      },
      calendar_id: null,
      time: {
        startDate: this.$moment.utc(new Date()).format("YYYY-MM-DD"),
        endDate: this.$moment.utc(new Date()).format("YYYY-MM-DD"),
      },
      timePicker: {
        start: "00:00",
        end: "00:30"
      },
      repeat: "never",
      onlineMeeting: "",
      attendees: [],
      calendars: []
    }
  },
  mounted() {
    this.get_calendars();
  },
  methods: {
    eventSubmit() {

    },
    get_calendars() {
      axios.get(this.crmApiPath + 'msgraph/calendar/calendars ').then(
          response => {
            if (response.data.is_redirect) {
              window.location.href = response.data.redirect_url;
            }
            else {
              this.calendars = response.data.calendars.data.value.filter(function (elem) {
                return elem.canEdit;
              });
              this.calendar_id = response.data.calendars.data.value[0].id;
            }
          }
      ).catch(
          error => console.log(error)
      );
    },
    createEvent() {
      this.event.start.dateTime = this.time.startDate + this.getTimeFormat(this.timePicker.start);
      this.event.end.dateTime = this.time.endDate + this.getTimeFormat(this.timePicker.end);
      this.event.recurrence = this.getRecurrenceObject(this.repeat);
      if (this.onlineMeeting === "") {
        this.event.isOnlineMeeting = false;
      }
      else {
        this.event.isOnlineMeeting = true;
        this.event.onlineMeetingProvider = this.onlineMeeting;
      }
      this.event.attendees = this.getAttendeesObject(this.attendees);
      axios.post(this.crmApiPath + 'msgraph/calendar/' + this.calendar_id + '/events', this.event).then(
          response => {
            if (response.data.is_redirect) {
              window.location.href = response.data.redirect_url;
            }
            else {
              this.$router.push({name: 'calendar'});
            }
          }
      ).catch(error => console.log(error));
    },
    dateFormat(date) {
      return this.$moment.utc(date).format("DD/MM/YYYY");
    },
    selectStartDate(startDate) {
      if (startDate != null) {
        this.time.startDate = this.$moment.utc(startDate).format('YYYY-MM-DD');
        this.time.endDate = this.$moment.utc(startDate).format('YYYY-MM-DD');
      }
    },
    getTimeFormat(str) {
      return "T" + str + ":00.0000000";
    },
    getRecurrenceObject(str) {
      if (str === "never") {
        return null;
      }
      else if (str === "daily") {
        return {
          pattern: {
            type: "daily",
            interval: 1
          },
          range: this.getGeneralRange()
        };
      }
      else if (str === "weekly") {
        return {
          pattern: {
            type: "weekly",
            interval: 1,
            daysOfWeek: [this.getWeekString(this.time.startDate)]
          },
          range: this.getGeneralRange()
        };
      }
      else if (str === "monthly") {
        return {
          pattern: {
            type: "absoluteMonthly",
            interval: 1
          },
          range: this.getGeneralRange()
        };
      }
      else if (str === "yearly") {
        return {
          pattern: {
            type: "absoluteYearly",
            interval: 1
          },
          range: this.getGeneralRange()
        };
      }
      else {
        return null;
      }
    },
    getGeneralRange() {
      return {
        type: "noEnd",
        startDate: this.time.startDate
      };
    },
    getWeekString(date) {
      const dayOfWeek = new Date(date).getDay();
      return isNaN(dayOfWeek) ? null : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayOfWeek];
    },
    getAttendeesObject(obj) {
      let that = this;
      return obj.filter(function (elem) {
        return that.validateEmail(elem);
      }).map(function (elem) {
        return {
          emailAddress: {
            address: elem,
          },
          type: "required"
        }
      });
    },
    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  },
}
</script>
<style scoped lang="scss">

</style>
<style lang="scss">
.crm-row {
  max-width:    1400px;
  margin-left:  auto;
  margin-right: auto;
}

.crm-submit-btn {
  background: #9a0054;
  color:      #ffffff;
}

.crm-multiselect {
  background: #ffffff;
}

.display-time {
  display:          block;
  width:            100% !important;
  height:           calc(1.6em + 0.75rem + 2px) !important;
  //padding:          0.375rem 0.75rem !important;
  font-size:        0.8rem !important;
  font-weight:      400;
  line-height:      1.6;
  color:            #495057;
  background-color: #ffffff;
  background-clip:  padding-box;
  border:           1px solid #ced4da;
  border-radius:    7.5px;
  transition:       border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.vue__time-picker .dropdown {
  top:  auto !important;
  left: auto !important;
}

.vue__time-picker {
  display: block !important;
  width:   auto;
}
</style>
